import { gql } from '@apollo/client'

export const UNREAD_NOTIFICATIONS_COUNT_QUERY = gql`
  query unreadNotificationsCount {
    unreadNotificationsCount
  }
`
